import React from 'react';
import PropTypes from 'prop-types';
import TrackResultTable from './TrackResultTable';
import {
  BH_POSTA,
  EURO_EXPRESS,
  MILSPED,
  POSTE_SRPSKE,
  X_EXPRESS,
  TRANSFERA,
} from '../const/serviceNames';

const TrackResults = ({ trackingResults }) => {
  const {
    tarckingResultsBihPoste,
    trackingResultsPosteSrpske,
    trackingResultsXexpress,
    trackingResultsEuroexpress,
    trackingResultsMilsped,
    trackingResultsTransfera,
  } = trackingResults;

  return (
    <>
      {tarckingResultsBihPoste && tarckingResultsBihPoste.length && (
        <TrackResultTable
          serviceName={BH_POSTA}
          trackingResults={tarckingResultsBihPoste}
        />
      )}

      {trackingResultsPosteSrpske && trackingResultsPosteSrpske.length && (
        <TrackResultTable
          serviceName={POSTE_SRPSKE}
          trackingResults={trackingResultsPosteSrpske}
        />
      )}
      {trackingResultsMilsped && trackingResultsMilsped.length && (
        <TrackResultTable
          serviceName={MILSPED}
          trackingResults={trackingResultsMilsped}
        />
      )}
      {trackingResultsXexpress && trackingResultsXexpress.length && (
        <TrackResultTable
          serviceName={X_EXPRESS}
          trackingResults={trackingResultsXexpress}
        />
      )}
      {trackingResultsEuroexpress && trackingResultsEuroexpress.length && (
        <TrackResultTable
          serviceName={EURO_EXPRESS}
          trackingResults={trackingResultsEuroexpress}
        />
      )}
      {trackingResultsTransfera && trackingResultsTransfera.length && (
        <TrackResultTable
          serviceName={TRANSFERA}
          trackingResults={trackingResultsTransfera}
        />
      )}
    </>
  );
};

TrackResults.propTypes = {
  trackingResults: PropTypes.object.isRequired,
};

export default TrackResults;
